/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_TitleInputs */

const en_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Subtitle Export`)
};

const fr_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lot de sous-titres`)
};

const de_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapel-Untertitelexport`)
};

const it_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione batch di sottotitoli`)
};

const ru_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт субтитров`)
};

const es_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de subtítulos por lotes`)
};

const zh_cn2_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出字幕`)
};

const ja_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕の一括エクスポート`)
};

const hi_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच उपशीर्षक निर्यात`)
};

const pt_pt2_batch_subtitle_export_title = /** @type {(inputs: Batch_Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote de legendas`)
};

/**
* | output |
* | --- |
* | "Batch Subtitle Export" |
*
* @param {Batch_Subtitle_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_title = /** @type {((inputs?: Batch_Subtitle_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_title(inputs)
	if (locale === "de") return de_batch_subtitle_export_title(inputs)
	if (locale === "it") return it_batch_subtitle_export_title(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_title(inputs)
	if (locale === "es") return es_batch_subtitle_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_title(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_title(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_title(inputs)
	return en_batch_subtitle_export_title(inputs)
});